/**
 * @desc 盘点审核明细导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inventoryMaster.inventoryApprovalExcel.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inventoryMaster/damageDetailExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
